// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__17uJp","header":"ReportDetails_header__1KNhJ","title":"ReportDetails_title__gOokF","left":"ReportDetails_left__2_uNu"};